import { RedoFulfillmentLocationSchema } from "@redotech/redo-model/fulfillments/fulfillment-location";
import * as z from "zod/v4";

export const getAllAssignableIMSSoTLocations = {
  name: "getAllAssignableIMSSoTLocations" as const,
  input: z.object({}),
  output: z.object({ locations: z.array(RedoFulfillmentLocationSchema) }),
};
